<!--
  @project E-School Web
  @author Vothana CHY
  @date 2026-07-28
-->

<script lang="ts" setup>
import { useI18n } from '#imports';

const { t } = useI18n();
</script>

<template>
  <div
    class="flex min-h-[40vh] flex-col items-center justify-center rounded-3xl border border-red-50 bg-white p-8 text-center shadow-xs"
  >
    <Icon name="lucide:wifi-off" class="mb-3 h-12 w-12 text-red-500" />
    <h3 class="text-lg font-bold text-gray-900">
      {{ t('courses.connectionError') }}
    </h3>
    <p class="mt-1 max-w-sm text-xs text-gray-500">
      {{ t('courses.connectionErrorDesc') }}
    </p>
  </div>
</template>
